export const GIZMO_TYPES = {
  ARRANGEMENT: 'ARRANGEMENT',
  DEFAULT: 'DEFAULT',
};
